import { DataGrid } from "@mui/x-data-grid";
import { dataGridDefaults } from "../../../../utils/constant";
import useColumnHide, {
  ColumnHiddenMessage,
  getColumnHideConfig,
} from "../../../../hooks/useColumnHide";
import { NoRowsOverlay } from "../../../../components/NoRowsOverlay";
import { CustomPagination } from "../../../../components/CustomPagination";
import { useReduxContext, setMerchantTabParams } from "../reduxContext";
import CreateRequestDialog from "./CreateRequestDialog";
import useTableColumns from "./helpers/useTableColumns";
import useListMapping from "./helpers/useListMapping";
import LoadingDialog from "../../../../components/LoadingDialog";
import useMerchantTabQuery from "../useMerchantTabQuery";

const ViewTable = () => {
  const [state, dispatch] = useReduxContext();
  const { merchantTabParams } = state;

  const { data, isLoading } = useMerchantTabQuery();

  const listMapping = useListMapping();
  const { rows = [], count = 0 } = data ?? {};
  const content = listMapping("key", rows);

  const onPageChange = (page: number) => {
    dispatch(setMerchantTabParams({ ...merchantTabParams, page }));
  };

  const { columns } = useTableColumns();

  const { colsShown, setColsShown, hasColHidden, localeText } = useColumnHide(
    columns,
    getColumnHideConfig()
  );

  if (isLoading) return <LoadingDialog forceOpen={true} />;

  return (
    <>
      <ColumnHiddenMessage hasColHidden={hasColHidden} />
      <CreateRequestDialog />
      <DataGrid
        {...dataGridDefaults}
        localeText={localeText}
        columnVisibilityModel={colsShown}
        onColumnVisibilityModelChange={setColsShown}
        rows={content}
        rowCount={count}
        columns={columns}
        page={state.merchantTabParams.page}
        onPageChange={onPageChange}
        components={{
          NoRowsOverlay,
          Footer: CustomPagination,
        }}
        componentsProps={{
          footer: {
            totalRecords: count,
          },
        }}
      />
    </>
  );
};

export default ViewTable;
